
import {
  reactive,
  toRefs,
  ref,
  watchEffect,
  onMounted,
  computed,
  defineComponent,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { getRoutes, GetCurrentMyPageList } from "../api/index";
import type { Response } from "../types/axios";
import type { MenuItem, MenuItemChildItem } from "../types/index";
import type { MenuProps } from "ant-design-vue";

export default defineComponent({
  name: "sidebar",
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const openKeys = ref<string[]>(["openapply", "openprocess", "approval"]);

    const data = reactive<{
      menuList: MenuItem[];
      total: number;
      selectedKeys: string[];
    }>({
      total: 0,
      menuList: [],
      selectedKeys: [],
    });
    onMounted(async () => {
      const { query } = route;
      if (
        sessionStorage.getItem("DefaultPath") &&
        sessionStorage.getItem("MenuResult") &&
        !query.ticket
      ) {
        SetMenu(false, JSON.parse(sessionStorage.getItem("MenuResult") || ""));
      } else {
        let result = await getRoutes();
        if (result) {
          sessionStorage.setItem("jurisdiction", result.Data.Menu[0].Operation);
          sessionStorage.setItem("MenuResult", JSON.stringify(result));
          sessionStorage.setItem("DefaultPath", result.Data.DefaultPath);
          SetMenu(true, result);
        }
      }
    });
    const SetMenu = (flag: boolean, result: Response) => {
      // result.Data.Menu.splice(3,0,{Child: null,DataAccess: "3",Icon: "changelist",Index: 41,IsDefault: 0,Level: 1,Name: "工商变更",Operation: "0",ParentMenuCode: null,Path: "/changelist",})
      result.Data.Menu?.forEach((item: MenuItem) => {
        item.Index = item.Icon;
        if (item.Child) {
          item.Child.forEach((e: MenuItemChildItem) => {
            e.Index = e.Path.slice(1);
          });
        }
      });
      data.menuList = result.Data.Menu;
      if (flag) {
        router.push({
          path: result.Data?.DefaultPath,
          query: { ...route.query },
        });
      }
      //todo:逻辑待完善
      // const obj = data.menuList.find((i) => i.Icon === "workBench");
      // if (!obj && !sessionStorage.getItem("jump")) {
      //   sessionStorage.setItem("jump", "1");
      //   router.push({
      //     name: "signsure",
      //   });
      // }
    };

    const handleClick: MenuProps["onClick"] = ({ key, item, keyPath }) => {
      let arr: {
        Name: string;
        operation: string;
      }[] = [];
      data.menuList.forEach((item: MenuItem) => {
        arr.push({
          Name: item.Index,
          operation: item.Operation,
        });
        if (item.Child) {
          // if (Object.prototype.hasOwnProperty.call(item, "Child")) {
          item.Child.forEach((e) => {
            arr.push({
              Name: e.Index,
              operation: e.Operation,
            });
          });
        }
      });
      arr.forEach((item) => {
        if (item.Name == key) {
          router.push({
            name: key as string,
            query: {
              operation: item.operation,
            },
          });
          sessionStorage.setItem("jurisdiction", item.operation);
        }
      });
    };
    const getList = async () => {
      const { Success, Data } = await GetCurrentMyPageList();

      if (Success) {
        store.commit("setWaitList", Data.ApproveCount);
        store.commit("setToList", Data.ToCCCount);
      }
    };
    onMounted(() => {
      getList();
    });

    watchEffect(() => {
      const pathRoute = route.path;
      const menuArr: MenuItemChildItem[] = [];
      data.menuList.forEach((item) => {
        if (item.Child) {
          item.Child.forEach((element) => {
            menuArr.push(element);
          });
        }
      });
      const mentAct = menuArr.find((item) => item.Path === pathRoute);
      if (mentAct) {
        data.selectedKeys.splice(0, 1, mentAct.Index);
      }
      let induArr = [
        {
          key: "openbook",
          list: ["/", "/openbook"],
        },
        {
          key: "process",
          list: [
            "/process/location",
            "/process/financial",
            "/process/registered",
            "/process/business",
            "/process/bank",
            "/process/employee",
            "/process/opening",
          ],
        },
        {
          key: "list",
          list: ["/processlist"],
        },
        // {
        //   key: "signsure",
        //   list: ["/signsure/detail"],
        // },
        // {
        //   key: "signconting",
        //   list: ["/signsure/detail"],
        // },
        // {
        //   key: "signlaunch",
        //   list: ["/signsure/detail"],
        // },
        // {
        //   key: "signcopy",
        //   list: ["/signsure/detail"],
        // },
      ];
      induArr.forEach((item, index) => {
        if (item.list.includes(route.path)) {
          data.selectedKeys = [item.key];
        }
      });
      if (route.path == "/signsure/detail") {
        if (route.query.tableFlag == "isFromMyCreatTable") {
          data.selectedKeys = ["signlaunch"];
        } else if (route.query.tableFlag == "isFromApproveTable") {
          data.selectedKeys = ["signconting"];
        } else if (route.query.tableFlag == "isFromCopyTable") {
          data.selectedKeys = ["signcopy"];
        } else {
          data.selectedKeys = ["signsure"];
        }
      }
      if (route.path.match(/\/process\/*/)) {
        if (route.query.tableFlag == "isFromProcessList") {
          data.selectedKeys = ["list"];
        }
      }
      if (route.path.match(/\/signsure\/*/)) {
        if (route.query.tableFlag == "isFromApplyTable") {
          data.selectedKeys = ["openlist"];
        }
      }
      if (
        route.path.match(/\/changelist?\/*/) ||
        route.path.match(/\/changeProcess?\/*/) ||
        route.path.match(/\/change?\/*/)
      ) {
        data.selectedKeys = ["changelist"];
      }
    });
    const num = computed(() => store.getters.getWaitList);
    const to_num = computed(() => store.getters.getToList);

    return {
      openKeys,
      ...toRefs(data),
      handleClick,
      num,
      to_num,
    };
  },
});
